<template>
  <div class="wait-confirm">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 该功能分配给售后公司用户 -->
        <el-form-item v-if="isAfterService && funcView.free_accessories_order_replace_part">
          <el-button type="primary" :disabled="!canReplacePart" @click="showReplacePart">{{ funcView.free_accessories_order_replace_part }}</el-button>
        </el-form-item>
        <!-- 待确认状态时显示 -->
        <!-- 该功能分配给售后公司用户 - 改为由权限控制 -->
        <el-form-item v-if="funcView.free_accessories_order_confirm">
          <el-button type="primary" :disabled="!areAfterServiceIdsSame" @click="onConfirm">{{ funcView.free_accessories_order_confirm }}</el-button>
        </el-form-item>
        <el-form-item v-if="isHq && funcView.free_accessories_order_cancel">
          <el-button type="primary" :disabled="!canCancel" @click="showCancel">{{ funcView.free_accessories_order_cancel }}</el-button>
        </el-form-item>

        <el-form-item style="float: right; margin-right: 0" v-if="funcView.free_accessories_order_export">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.free_accessories_order_export }">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_wait_confirm.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 高级搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_wait_confirm.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.zeng_song_pei_jian')">
          <el-input v-model="formSearch.partCodeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.qrskrq')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.finalPayment"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.chuang_jian_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.gmtCreate"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_wait_confirm.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        tableCode="free_part_order_wait_confirm"
        :clickSelection="true"
        ref="table"
        v-model="tableSelect"
        type="checkbox"
        :data="tableList"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['orderGoodsCode', 'contractNo', 'billTermNum']"
      >
        <template v-slot:orderGoodsCode="scope">
          <span v-if="funcView.free_accessories_order_order_detail" class="cell-link" @click.stop="showDetail(scope.row)">{{ scope.row.orderGoodsCode }}</span>
          <span v-else>{{ scope.row.orderGoodsCode }}</span>
        </template>
        <template v-slot:contractNo="scope">
          <span class="cell-link" @click="toContractDetail(scope.row)">{{ scope.row.contractNo || '-' }}</span>
        </template>
        <template v-slot:billTermNum="scope">
          <div>
            {{ scope.row.billTermNum ? `${scope.row.billTermNum}/${scope.row.billTotalTerm}` : '-' }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <div class="table-sum-params">
        <div class="sum-item">
          <div class="key">{{ $t('crm_wait_confirm.yi_xuan_zhong') }}</div>
          <div class="val selected-num">{{ tableSelect.length }}</div>
          <div class="key">{{ $t('crm_wait_confirm.xiang') }}</div>
          <div class="key">，</div>
        </div>
        <div class="sum-item">
          <div class="key">{{ $t('crm_wait_confirm.he_ji') }}：</div>
          <div class="val selected-num">{{ bookingNumTotal }}</div>
        </div>
        <div class="sum-item ml-10">
          <div class="key">{{ $t('crm_wait_confirm.zpjsl') }}：</div>
          <div class="val selected-num">{{ totalPartNum }}</div>
        </div>
      </div>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <cancel-dialog v-if="cancelVisible" :model="cancelModel" @close="cancelVisible = false" @confirm="onCancelConfirm"></cancel-dialog>
    <replace-part-dialog v-if="replacePartVisible" :model="replacePartModel" @close="replacePartVisible = false" @confirm="onReplacePartConfirm"></replace-part-dialog>
    <part-order-detail-dialog v-if="detailVisible" @close="detailVisible = false" :model="detailModel" @infoChange="getTableList"></part-order-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import cancelDialog from './cancel_dialog.vue';
import replacePartDialog from './replace_part_dialog.vue';
import partOrderDetailDialog from '../../components/part_order_detail_dialog.vue';
import mixins from './mixins.js';

export default {
  name: '',
  mixins: [mixins],
  components: {
    cancelDialog,
    replacePartDialog,
    partOrderDetailDialog,
  },
  props: {},
  data() {
    return {
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,

        // 产品型号
        productCode: '',

        // 赠送配件
        partCodeName: '',

        // 合同编号
        contractNo: '',

        // 售后公司
        afterServiceName: '',
        // 最终支付日期
        finalPayment: '',
        // 创建日期
        gmtCreate: '',
        // 项目名称
        locationName: '',

        // 6-待确认，10-已确认，20-待发货，22-已收货，100-已作废
        type: '',
      },
      link: null,

      tableList: [],
      tableSelect: [],

      totalRows: null,

      // 总配件数
      totalPartNum: 0,

      // 作废
      cancelVisible: false,
      cancelModel: {},

      // 更换配件
      replacePartVisible: false,
      replacePartModel: {},

      // 配送订单详情
      detailVisible: false,
      detailModel: {},
    };
  },
  computed: {
    // 是否可以更换配件
    // 待确认列表，且允许更换为 是 时 该按钮可用
    canReplacePart() {
      if (this.tableSelect.length) {
        const isAllReplace = !this.tableSelect.some((item) => `${item.isReplace}` === '0');
        return isAllReplace;
      }
      return false;
    },
    // 是否可以确认
    // 订单号必须相同 orderGoodsCode(阿康说的)
    canConfirm() {
      const map = {};
      this.tableSelect.forEach((item) => {
        map[item.orderGoodsCode] = 1;
      });

      const sameOrderCode = Object.keys(map).length === 1;

      return this.tableSelect.length && sameOrderCode;
    },
    areAfterServiceIdsSame() {
      if (this.tableSelect.length === 0) {
        return false; // 数组为空
      }

      const firstAfterServiceId = this.tableSelect[0].afterServiceId;
      return this.tableSelect.every((item) => item.afterServiceId === firstAfterServiceId);
    },
    // 是否可以作废
    canCancel() {
      return this.tableSelect.length === 1;
    },

    // 赠送数量合计
    bookingNumTotal() {
      return this.tableSelect.reduce((total, obj) => total + (obj.bookingNum || 0), 0);
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onConfirm() {
      this.$showConfirm(this.$t('crm_wait_confirm.nqdsxzsdpjxxsyxdm')).then(() => {
        // const orderGoodsCode = this.tableSelect[0].orderGoodsCode;
        const reqData = this.tableSelect.map((t) => t.orderGoodsCode);
        this.$postJSON(apis.giveawayBatchConfirm, reqData).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },

    getReqData() {
      const { finalPayment, gmtCreate } = this.formSearch;
      const reqData = { ...this.formSearch };
      if (finalPayment && finalPayment.length) {
        reqData.finalPaymentStartTime = finalPayment[0];
        reqData.finalPaymentEndTime = finalPayment[1];
      }
      if (gmtCreate && gmtCreate.length) {
        reqData.createStartTime = gmtCreate[0];
        reqData.createEndTime = gmtCreate[1];
      }
      delete reqData.finalPayment;
      delete reqData.gmtCreate;
      return reqData;
    },

    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.giveawayPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
      this.$getJSON(apis.giveawayCount, reqData).then((res) => {
        this.totalPartNum = res.data || 0;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },

    // 作废
    showCancel() {
      this.cancelModel = {
        title: this.$t('crm_wait_confirm.zuo_fei'),
        data: this.tableSelect,
      };
      this.cancelVisible = true;
    },
    onCancelConfirm() {
      this.getTableList();
    },

    // 更换配件
    showReplacePart() {
      this.replacePartModel = {
        title: this.$t('crm_wait_confirm.geng_huan_pei_jian'),
        data: this.tableSelect,
      };

      this.replacePartVisible = true;
    },

    onReplacePartConfirm() {
      this.getTableList();
    },

    // 配送订单详情
    showDetail(row) {
      this.detailModel = {
        title: this.$t('crm_wait_confirm.psddxq'),
        data: row,
      };
      this.detailVisible = true;
    },

    // 合同编号详情

    onDetailConfirm() {},

    exportTable() {
      const data = this.getReqData();
      delete data.pageNum;
      delete data.pageSize;

      this.$exportFlie(apis.giveawayExport, data).catch(() => {
        this.$message({
          message: this.$t('crm_wait_confirm.cao_zuo_shi_bai'),
          type: 'error',
        });
      });
    },
  },
  created() {},
  mounted() {
    // 应收账单查看赠送配件
    if (this.getJump('action') === 'view') {
      const orderGoodsCode = this.getJump('orderGoodsCode');
      const orderGiveawayId = this.getJump('orderGiveawayId');
      this.detailModel = {
        title: this.$t('crm_wait_confirm.psddxq'),
        data: { orderGoodsCode, orderGiveawayId },
      };
      this.detailVisible = true;
      // 改成已读 以防频发弹框
      this.$router.replace({
        query: {
          ...this.$route.query, // 保留其他查询参数
          action: 'viewed', // 修改 action 参数
        },
      });
    }
    this.getDicMap('giveaway_biz_state', () => {
      this.formSearch.type = this.dicMap.giveaway_biz_state.wait_confirm;
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getFuncView(null, () => {
        setTimeout(() => {
          this.link = this.$refs.container;
        }, 500);
      });

      this.getTableList();
    });
  },
};
</script>

<style lang="scss" scoped>
.wait-confirm {
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-sum-params {
  float: left;
  overflow: hidden;

  .selected-num {
    padding: 0 5px;
    color: #0d9ae0;
  }

  .sum,
  .price {
    color: #0d9ae0;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .sum-item {
    float: left;
    line-height: 32px;
    font-size: 12px;
    color: #606266;

    .key,
    .val {
      float: left;
    }
  }
}
</style>
